import script from "./PageHero.vue?vue&type=script&setup=true&lang=js"
export * from "./PageHero.vue?vue&type=script&setup=true&lang=js"

import "./PageHero.vue?vue&type=style&index=0&id=00aa34f5&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist-eni-for-2022-hub-e-longform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00aa34f5"]])

export default __exports__